import { render, staticRenderFns } from "./userOrders.vue?vue&type=template&id=b67ba4fe&scoped=true&"
import script from "./userOrders.vue?vue&type=script&lang=js&"
export * from "./userOrders.vue?vue&type=script&lang=js&"
import style0 from "./userOrders.vue?vue&type=style&index=0&id=b67ba4fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67ba4fe",
  null
  
)

export default component.exports